import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { BaseForm } from "@app/data/shared/models/base-form.interface";
import { TaxareaListComponent } from "@dashboard/modules/application-params/taxarea/components/taxarea-list/taxarea-list.component";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { KlSweetAlertService } from "@app/modules/shared/services/message/kl-sweet-alert.service";
import { UtilService } from "@app/modules/shared/services/util.service";
import { ToastService } from "@app/modules/shared/services/message/toast.service";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { ConvertIsoDateService } from "@app/modules/shared/services/convert-iso-date.service";
import {
  ExplorerService,
  ModalConfig,
} from "@app/modules/shared/services/explorer.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { DocumentTypesEnum } from "@app/modules/shared/enum/document-types.enum";
import { DynamicComponent } from "@app/data/dashboard/interfaces/dynamic-component.interface";
import { CustomerDto } from "@dashboard/modules/shipping-management/customer/model/customer.dto";
import { forkJoin, of, Subscription } from "rxjs";
import { CurrentAccountListComponent } from "@dashboard/modules/finance-management/current-account/components/current-account-list/current-account-list.component";
import { catchError, finalize } from "rxjs/operators";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "kl-customer-form",
  templateUrl: "./customer-form.component.html",
  styleUrls: ["./customer-form.component.scss"],
})
export class CustomerFormComponent
  implements OnInit, AfterViewInit, OnDestroy, BaseForm
{
  @Input() isReadOnly: boolean;
  @Input() tabId: string;
  @Input() listTabId: string;
  @Input() modalId: string;
  @Input() mode: string;
  @Input() entity: CustomerDto = new CustomerDto();
  @ViewChild("customerForm", { static: true }) private customerForm: any;
  @ViewChild("focusElement", { static: true }) private elementFocus: ElementRef;
  title = "";
  apiError: boolean;
  validationError = false;
  alertType: string;
  alertMessage: any;
  generateCodeSpin = false;
  isOpenFirstAccordion = true;
  isOpenSecondAccordion = false;
  isOpenThirdAccordion = false;
  isOpenFifth = false;
  countryList = [];
  regionList = [];
  stateList = [];
  cityList = [];
  countyList = [];
  sectorList = [];
  currencyList = [];
  countryChange = false;
  regionChange = false;
  stateChange = false;
  cityChange = false;
  regionStatus = false;
  stateStatus = false;
  taxNumberError = false;
  changeStatus = false;
  is_private: boolean;
  today: any;
  type: any;
  subscription: Subscription;
  subscriptionUserDetail: Subscription;
  curr_account_id: number;

  CurrentAccountList = CurrentAccountListComponent;
  TaxareaList = TaxareaListComponent;

  constructor(
    private apiService: ApiService,
    private sweetAlert: KlSweetAlertService,
    private utilService: UtilService,
    private toastService: ToastService,
    private translateService: TranslateService,
    private dateConvert: ConvertIsoDateService,
    private explorerService: ExplorerService,
    private klLoadingService: KlLoadingService,
    private cd: ChangeDetectorRef
  ) {
    this.subscription = explorerService.transferState$.subscribe((state) => {
      this.formChange(true);
      switch (state.state) {
        case "TAX_AREA_CURRENT_ITEM":
          this.entity.tax_office = state.payload.description;
          this.cd.markForCheck();
          break;
        case "CURRENT_ACCOUNT_CURRENT_ITEM":
          if (state.payload) {
            if (state.payload.status === "ACTIVE") {
              this.entity.current_account = state.payload;
            } else {
              this.handleError("current_account_is_closed_to_use");
            }
          }
          this.cd.markForCheck();
          break;
      }
    });
    this.subscriptionUserDetail = explorerService.userStream$.subscribe(
      (userDetail) => {
        if (userDetail) {
          this.curr_account_id = userDetail.curr_account_id;
        }
      }
    );
  }

  ngOnInit() {
    this.klLoadingService.show("loading");
    switch (this.mode) {
      case "add":
        if (!this.entity.type) {
          this.entity.type = DocumentTypesEnum.CUSTOMER_SELLER;
        }
        this.entity.status = "ACTIVE";
        this.generateCode();
        this.apiService
          .getLocationsByType("COUNTRY")
          .finally(() => {
            this.klLoadingService.hide();
            this.cd.markForCheck();
          })
          .subscribe(
            (resCountry) => (this.countryList = resCountry),
            (error) => this.handleError(error)
          );
        this.title =
          this.translateService.instant("new") +
          " " +
          this.translateService.instant("customer");
        break;
      case "edit":
      case "view":
        this.is_private = this.entity.is_private === "YES";
        this.apiService.getLocationsByType("COUNTRY").subscribe(
          (resCountryList) => {
            this.countryList = resCountryList;
            if (this.entity.country) {
              this.entity.country = this.countryList.find(
                (filterCountry) => filterCountry.id === this.entity.country.id
              );
              this.apiService
                .getLocationExist(this.entity.country.id, "REGION")
                .subscribe(
                  (resRegionExists) => {
                    this.regionStatus = resRegionExists.exists;
                    if (this.regionStatus) {
                      /* Bolge varsa */
                      this.apiService
                        .getLocationByParentId(this.entity.country.id)
                        .subscribe(
                          (resRegionList) => {
                            this.regionList = resRegionList;
                            if (this.entity.region) {
                              this.entity.region = this.regionList.find(
                                (filterRegion) =>
                                  filterRegion.id === this.entity.region.id
                              );
                              this.apiService
                                .getLocationExist(
                                  this.entity.region.id,
                                  "STATE"
                                )
                                .subscribe(
                                  (resStateExists) => {
                                    /* Bolge ve Eyalet var */
                                    this.stateStatus = resStateExists.exists;
                                    if (this.stateStatus) {
                                      this.apiService
                                        .getLocationByParentId(
                                          this.entity.region.id
                                        )
                                        .subscribe(
                                          (resStateList) => {
                                            this.stateList = resStateList;
                                            if (this.entity.state) {
                                              this.stateList.filter(
                                                (filterState) => {
                                                  if (
                                                    filterState.id ===
                                                    this.entity.state.id
                                                  ) {
                                                    this.entity.state =
                                                      filterState;
                                                  }
                                                }
                                              );
                                              this.apiService
                                                .getLocationByParentId(
                                                  this.entity.state.id
                                                )
                                                .subscribe(
                                                  (resCityList) => {
                                                    this.cityList = resCityList;
                                                    if (this.entity.city) {
                                                      this.cityList.filter(
                                                        (filterCity) => {
                                                          if (
                                                            filterCity.id ===
                                                            this.entity.city.id
                                                          ) {
                                                            this.entity.city =
                                                              filterCity;
                                                          }
                                                        }
                                                      );
                                                      this.apiService
                                                        .getLocationByParentId(
                                                          this.entity.city.id
                                                        )
                                                        .subscribe(
                                                          (resCountyList) => {
                                                            this.countyList =
                                                              resCountyList;
                                                            if (
                                                              this.entity.county
                                                            ) {
                                                              this.countyList.filter(
                                                                (
                                                                  filterCounty
                                                                ) => {
                                                                  if (
                                                                    filterCounty.id ===
                                                                    this.entity
                                                                      .county.id
                                                                  ) {
                                                                    this.entity.county =
                                                                      filterCounty;
                                                                  }
                                                                }
                                                              );
                                                            }
                                                            this.klLoadingService.hide();
                                                            this.cd.markForCheck();
                                                          },
                                                          (errCountyList) => {
                                                            this.handleError(
                                                              errCountyList
                                                            );
                                                          }
                                                        );
                                                    } else {
                                                      this.klLoadingService.hide();
                                                      this.cd.markForCheck();
                                                    }
                                                  },
                                                  (errCityList) => {
                                                    this.handleError(
                                                      errCityList
                                                    );
                                                  }
                                                );
                                            } else {
                                              this.klLoadingService.hide();
                                              this.cd.markForCheck();
                                            }
                                          },
                                          (errStateList) => {
                                            this.handleError(errStateList);
                                          }
                                        );
                                    } else {
                                      /* Bolge var eyalet yok */
                                      this.apiService
                                        .getLocationByParentId(
                                          this.entity.region.id
                                        )
                                        .subscribe(
                                          (resCityList) => {
                                            this.cityList = resCityList;
                                            if (this.entity.city) {
                                              this.cityList.filter(
                                                (filterCity) => {
                                                  if (
                                                    filterCity.id ===
                                                    this.entity.city.id
                                                  ) {
                                                    this.entity.city =
                                                      filterCity;
                                                  }
                                                }
                                              );
                                              this.apiService
                                                .getLocationByParentId(
                                                  this.entity.city.id
                                                )
                                                .subscribe(
                                                  (resCountyList) => {
                                                    this.countyList =
                                                      resCountyList;
                                                    if (this.entity.county) {
                                                      this.countyList.filter(
                                                        (filterCounty) => {
                                                          if (
                                                            filterCounty.id ===
                                                            this.entity.county
                                                              .id
                                                          ) {
                                                            this.entity.county =
                                                              filterCounty;
                                                          }
                                                        }
                                                      );
                                                    }
                                                    this.klLoadingService.hide();
                                                    this.cd.markForCheck();
                                                  },
                                                  (errCountyList) => {
                                                    this.handleError(
                                                      errCountyList
                                                    );
                                                  }
                                                );
                                            } else {
                                              this.klLoadingService.hide();
                                              this.cd.markForCheck();
                                            }
                                          },
                                          (errCityList) => {
                                            this.handleError(errCityList);
                                          }
                                        );
                                    }
                                  },
                                  (errStateExists) => {
                                    this.handleError(errStateExists);
                                  }
                                );
                            } else {
                              this.klLoadingService.hide();
                              this.cd.markForCheck();
                            }
                          },
                          (errRegionList) => {
                            this.handleError(errRegionList);
                          }
                        );
                    } else {
                      /* Bolge yok */
                      this.apiService
                        .getLocationExist(this.entity.country.id, "STATE")
                        .subscribe(
                          (resStateExists) => {
                            this.stateStatus = resStateExists.exists;
                            if (this.stateStatus) {
                              this.apiService
                                .getLocationByParentId(this.entity.country.id)
                                .subscribe(
                                  (resStateList) => {
                                    this.stateList = resStateList;
                                    if (this.entity.state) {
                                      this.stateList.filter((filterState) => {
                                        if (
                                          filterState.id ===
                                          this.entity.state.id
                                        ) {
                                          this.entity.state = filterState;
                                        }
                                      });
                                      this.apiService
                                        .getLocationByParentId(
                                          this.entity.state.id
                                        )
                                        .subscribe(
                                          (resCityList) => {
                                            this.cityList = resCityList;
                                            if (this.entity.city) {
                                              this.cityList.filter(
                                                (filterCity) => {
                                                  if (
                                                    filterCity.id ===
                                                    this.entity.city.id
                                                  ) {
                                                    this.entity.city =
                                                      filterCity;
                                                  }
                                                }
                                              );
                                              this.apiService
                                                .getLocationByParentId(
                                                  this.entity.city.id
                                                )
                                                .subscribe(
                                                  (resCountyList) => {
                                                    this.countyList =
                                                      resCountyList;
                                                    if (this.entity.county) {
                                                      this.countyList.filter(
                                                        (filterCounty) => {
                                                          if (
                                                            filterCounty.id ===
                                                            this.entity.county
                                                              .id
                                                          ) {
                                                            this.entity.county =
                                                              filterCounty;
                                                          }
                                                        }
                                                      );
                                                    }
                                                    this.klLoadingService.hide();
                                                    this.cd.markForCheck();
                                                  },
                                                  (errCountyList) => {
                                                    this.handleError(
                                                      errCountyList
                                                    );
                                                  }
                                                );
                                            }
                                          },
                                          (errCityList) => {
                                            this.handleError(errCityList);
                                          }
                                        );
                                    }
                                  },
                                  (errStateList) => {
                                    this.handleError(errStateList);
                                  }
                                );
                            } else {
                              /* Bolge Eyalet yoksa */
                              this.apiService
                                .getLocationByParentId(this.entity.country.id)
                                .subscribe(
                                  (resCityList) => {
                                    this.cityList = resCityList;
                                    if (this.entity.city) {
                                      this.cityList.filter((filterCity) => {
                                        if (
                                          filterCity.id === this.entity.city.id
                                        ) {
                                          this.entity.city = filterCity;
                                        }
                                      });
                                      this.apiService
                                        .getLocationByParentId(
                                          this.entity.city.id
                                        )
                                        .subscribe(
                                          (resCountyList) => {
                                            this.countyList = resCountyList;
                                            if (this.entity.county) {
                                              this.countyList.filter(
                                                (filterCounty) => {
                                                  if (
                                                    filterCounty.id ===
                                                    this.entity.county.id
                                                  ) {
                                                    this.entity.county =
                                                      filterCounty;
                                                  }
                                                }
                                              );
                                            }
                                            this.klLoadingService.hide();
                                            this.cd.markForCheck();
                                          },
                                          (errCountyList) => {
                                            this.handleError(errCountyList);
                                          }
                                        );
                                    }
                                  },
                                  (errCityList) => {
                                    this.handleError(errCityList);
                                  }
                                );
                            }
                          },
                          (errStateExists) => {
                            this.handleError(errStateExists);
                          }
                        );
                    }
                  },
                  (errRegionExists) => {
                    this.handleError(errRegionExists);
                  }
                );
            } else {
              this.klLoadingService.hide();
              this.cd.markForCheck();
            }
          },
          (errCountryList) => {
            this.handleError(errCountryList);
          }
        );
        this.title = this.translateService.instant("customer") + " - ";
        break;
    }
    const sectorRequest = this.apiService
      .getFilteredData("sector", { filter: { status: "ACTIVE" } })
      .pipe(catchError((error: any) => this.handleError(error)));
    this.today = this.dateConvert.convertDate(new Date());
    const currencyRequest = this.apiService
      .getFilterDataByDate("currency/rate", this.today)
      .pipe(catchError((error: any) => this.handleError(error)));
    forkJoin([sectorRequest, currencyRequest])
      .pipe(
        finalize(() => {
          this.cd.markForCheck();
        })
      )
      .subscribe(
        ([sectorResponse, currencyResponse]) => {
          if (this.curr_account_id) {
            this.apiService
              .getDataById("current-account", this.curr_account_id)
              .subscribe(
                (response) => {
                  this.klLoadingService.hide();
                  if (response === undefined) {
                    this.handleError("error_data");
                  } else {
                    this.entity.current_account = response;
                  }
                  this.cd.markForCheck();
                },
                (error) => this.handleError(error)
              );
          } else {
            this.klLoadingService.hide();
            this.cd.markForCheck();
          }
          this.sectorList = sectorResponse
            ? sectorResponse.data
              ? sectorResponse.data
              : []
            : [];
          this.currencyList = currencyResponse ? currencyResponse : [];
          if (this.mode === "add") {
            this.entity.sector = this.sectorList[0] ? this.sectorList[0] : null;
            this.entity.currency = this.currencyList.find(
              (currency) => currency.code === "TRY"
            );
            if (!this.entity.currency) {
              this.entity.currency = this.currencyList[0];
            }
          }
        },
        (errSector) => this.handleError(errSector)
      );
  }

  ngAfterViewInit() {
    this.elementFocus.nativeElement.focus();
    this.cd.markForCheck();
  }

  formChange(event) {
    if (this.tabId) {
      this.explorerService.changeFormStatus({
        tabId: this.tabId,
        changeForm: event,
      });
    }
  }

  isPrivateChange(event) {
    this.formChange(true);
    if (event) {
      delete this.entity.tax_num;
    } else {
      delete this.entity.identity_num;
    }
  }

  identityChange() {
    this.formChange(true);
    this.taxNumberError = false;
  }

  taxNumberChange() {
    this.formChange(true);
    this.taxNumberError = false;
  }

  handleResponse(response) {
    this.formChange(false);
    this.klLoadingService.hide();
    this.toastService.toastSuccess();
    if (this.tabId) {
      this.explorerService.closeTab(this.tabId);
    }
    if (this.modalId) {
      this.explorerService.closeModal(this);
    }
    if (this.listTabId) {
      this.explorerService.setRefreshEndProsseses(this.listTabId);
    }
    this.cd.markForCheck();
  }

  handleNew(response) {
    this.formChange(false);
    this.apiError = false;
    this.validationError = false;
    this.klLoadingService.hide();
    this.toastService.toastSuccess();
    this.clearForm();
    this.cd.markForCheck();
  }

  handleError(error, errorType = "apiError") {
    this[errorType] = true;
    this.alertType = "error";
    this.alertMessage = this.utilService.alertErrorMessage(error);
    this.klLoadingService.hide();
    this.cd.markForCheck();
    return of(null);
  }

  unlockEntity() {
    this.apiService.unlockData("customer", this.entity.id).subscribe();
  }

  setModal(title: string, stateSelector: string, template: any, modalId) {
    const modalConfig = <ModalConfig>{
      title: title,
      stateSelector: stateSelector,
      childTemplate: <DynamicComponent>{
        mode: "DIALOG",
        modalId: modalId,
        dblSelect: true,
        template: template,
      },
    };
    this.explorerService.openModal(modalConfig);
  }

  commitSave(action?: string) {
    if (this.customerForm.valid && this.entity.current_account) {
      this.klLoadingService.show("saving");
      if (this.entity.country) {
        this.entity.country = {
          id: this.entity.country.id,
        };
      }
      if (this.entity.region) {
        this.entity.region = {
          id: this.entity.region.id,
        };
      }
      if (this.entity.state) {
        this.entity.state = {
          id: this.entity.state.id,
        };
      }
      if (this.entity.city) {
        this.entity.city = {
          id: this.entity.city.id,
        };
      }
      if (this.entity.county) {
        this.entity.county = {
          id: this.entity.county.id,
        };
      }
      this.entity.is_private = this.is_private ? "YES" : "NO";
      if (this.is_private) {
        if (this.entity.identity_num) {
          this.taxNumberError = false;
        } else {
          this.taxNumberError = true;
          this.isOpenSecondAccordion = true;
        }
      } else {
        if (this.entity.tax_num) {
          this.taxNumberError = false;
        } else {
          this.taxNumberError = true;
          this.isOpenSecondAccordion = true;
        }
      }
      if (this.taxNumberError) {
        this.handleError("required_fields_must_be_entered");
      } else {
        switch (action) {
          case "SAVE":
            switch (this.mode) {
              case "add":
                this.apiService.addData("customer", this.entity).subscribe(
                  (response) => this.handleResponse(response),
                  (error) => this.handleError(error)
                );
                break;
              case "edit":
                this.apiService.updateData("customer", this.entity).subscribe(
                  (response) => this.handleResponse(response),
                  (error) => this.handleError(error)
                );
                break;
            }
            break;
          case "SAVE_NEW":
            this.apiService.addData("customer", this.entity).subscribe(
              (response) => this.handleNew(response),
              (error) => this.handleError(error)
            );
            break;
        }
      }
    } else {
      this.handleError("required_fields_must_be_entered", "validationError");
    }
  }

  generateCode() {
    this.generateCodeSpin = true;
    this.apiService
      .generateCode("customer")
      .finally(() => {
        this.generateCodeSpin = false;
      })
      .subscribe(
        (resCode) => {
          this.formChange(true);
          this.entity.code = resCode.value;
          this.cd.markForCheck();
        },
        (errCode) => {
          this.handleError(errCode);
        }
      );
  }

  clearForm() {
    Object.keys(this.entity).forEach((key) => {
      if (key !== "current_account") {
        delete this.entity[key];
      }
    });
    this.generateCode();
    this.elementFocus.nativeElement.focus();
    this.is_private = false;
    this.entity.status = "ACTIVE";
    this.entity.sector = this.sectorList[0] ? this.sectorList[0] : null;
    this.entity.currency = this.currencyList.find(
      (currency) => currency.code === "TRY"
    );
    if (!this.entity.currency) {
      this.entity.currency = this.currencyList[0];
    }
  }

  clearTaxOffice() {
    this.formChange(true);
    this.entity.tax_office = "";
  }

  clearCurrentAccount() {
    this.formChange(true);
    this.entity.current_account = null;
  }

  onCountryChange(event) {
    this.clearRegion();
    this.countryChange = true;
    this.changeStatus = true;
    this.apiService
      .getLocationExist(event.value.id, "region")
      .subscribe((check) => {
        this.regionStatus = check.exists;
        if (check.exists) {
          this.apiService
            .getLocationByParentId(event.value.id)
            .subscribe((regions) => {
              this.countryChange = false;
              this.changeStatus = false;
              this.regionList = regions;
              this.cd.markForCheck();
            });
        } else {
          this.apiService
            .getLocationExist(event.value.id, "state")
            .subscribe((checkState) => {
              this.stateStatus = checkState.exists;
              if (checkState.exists) {
                this.apiService
                  .getLocationByParentId(event.value.id)
                  .subscribe((states) => {
                    this.countryChange = false;
                    this.changeStatus = false;
                    this.stateList = states;
                    this.cd.markForCheck();
                  });
              } else {
                this.apiService
                  .getLocationByParentId(event.value.id)
                  .subscribe((cities) => {
                    this.countryChange = false;
                    this.changeStatus = false;
                    this.cityList = cities;
                    this.cd.markForCheck();
                  });
              }
            });
        }
      });
  }

  onRegionChange(event) {
    this.clearState();
    this.regionChange = true;
    this.changeStatus = true;
    this.apiService
      .getLocationExist(event.value.id, "state")
      .subscribe((check) => {
        if (check.exists) {
          this.apiService
            .getLocationByParentId(event.value.id)
            .subscribe((states) => {
              this.regionChange = false;
              this.changeStatus = false;
              this.stateList = states;
              this.cd.markForCheck();
            });
        } else {
          this.apiService
            .getLocationByParentId(event.value.id)
            .subscribe((cities) => {
              this.regionChange = false;
              this.changeStatus = false;
              this.cityList = cities;
              this.cd.markForCheck();
            });
        }
      });
  }

  onStateChange(event) {
    this.clearCity();
    this.stateChange = true;
    this.changeStatus = true;
    this.apiService
      .getLocationExist(event.value.id, "city")
      .subscribe((check) => {
        if (check.exists) {
          this.apiService
            .getLocationByParentId(event.value.id)
            .subscribe((cities) => {
              this.stateChange = false;
              this.changeStatus = false;
              this.cityList = cities;
              this.cd.markForCheck();
            });
        }
      });
  }

  onCityChange(event) {
    this.formChange(true);
    this.countyList = [];
    this.entity.county = null;
    this.cityChange = true;
    this.changeStatus = true;
    this.apiService
      .getLocationExist(event.value.id, "county")
      .subscribe((check) => {
        if (check.exists) {
          this.apiService.getLocationByParentId(event.value.id).subscribe(
            (counties) => {
              this.cityChange = false;
              this.changeStatus = false;
              this.countyList = counties;
              this.cd.markForCheck();
            },
            (error) => this.handleError(error)
          );
        }
      });
  }

  clearCountry() {
    this.formChange(true);
    this.entity.country = null;
    this.entity.region = null;
    this.regionList = [];
    this.entity.state = null;
    this.stateList = [];
    this.entity.city = null;
    this.cityList = [];
    this.entity.county = null;
    this.countyList = [];
  }

  clearRegion() {
    this.formChange(true);
    this.entity.region = null;
    this.entity.state = null;
    this.stateList = [];
    this.entity.city = null;
    this.cityList = [];
    this.entity.county = null;
    this.countyList = [];
  }

  clearState() {
    this.formChange(true);
    this.entity.state = null;
    this.entity.city = null;
    this.cityList = [];
    this.entity.county = null;
    this.countyList = [];
  }

  clearCity() {
    this.formChange(true);
    this.entity.city = null;
    this.entity.county = null;
    this.countyList = [];
  }

  ngOnDestroy() {
    if (this.mode === "edit") {
      this.unlockEntity();
    }
    this.subscription.unsubscribe();
    this.subscriptionUserDetail.unsubscribe();
  }
}
